<template>
  <div ref="roleSectionForm">
    <BaseFormLayout
      :title="`${editMode ? 'Edit' : 'Add'} ${configurationModule.role}`"
      :backRoute="backRoute"
      :nonFieldError="nonFieldError"
    >
      <template #content>
        <v-card elevation="0" class="rounded-lg">
          <v-form v-model="isValid" ref="roleForm" id="roleForm">
            <v-row no-gutters class="px-5 pt-6">
              <v-col cols="6" lg="4">
                <InputField
                  id="name"
                  outlined
                  class="background-white"
                  name="name"
                  :required="true"
                  :label="`${configurationModule.role} name`"
                  :rules="[
                    (v) =>
                      !/[^a-zA-Z0-9 ]/.test(v) ||
                      'Special characters are not allowed',
                  ]"
                  :error-messages="formErrors ? formErrors.name : ''"
                  v-model="roleDetails.name"
                ></InputField>
              </v-col>
              <v-col
                cols="12"
                class="d-flex justify-space-between pt-8 pb-6 px-3"
              >
                <span
                  class="font-weight-bold text-subtitle-1 text-capitalize"
                  color="grey"
                >
                  permissions
                </span>
                <SecondaryButton
                  id="roleSelectAll"
                  @click="selectAllPermission"
                  btnClass="text-uppercase"
                  :name="isAllSelected ? 'Unselect all' : 'Select All'"
                >
                </SecondaryButton>
              </v-col>

              <v-col cols="12">
                <v-row class="px-0 pb-12">
                  <v-col cols="12" class="primary lighten-1 px-10">
                    <v-row>
                      <v-col>
                        <span class="text-capitalize white--text">
                          module
                        </span>
                      </v-col>
                      <v-col class="d-flex algin-center">
                        <v-checkbox
                          color="success"
                          class="my-0 mr-2 ml-0 view-checkbox"
                          :input-value="isAllViewSelected"
                          @click="toggleAllViewPermission"
                          hide-details
                        >
                        </v-checkbox>
                        <span class="text-capitalize pt-1 white--text">
                          view
                        </span>
                      </v-col>
                      <v-col class="d-flex algin-center">
                        <v-checkbox
                          color="success"
                          class="my-0 mr-2 ml-0 view-checkbox"
                          :value="isAllAddSelected"
                          @click="toggleAllAddPermission"
                          hide-details
                        >
                        </v-checkbox>
                        <span class="text-capitalize pt-1 white--text">
                          add
                        </span>
                      </v-col>
                      <v-col class="d-flex algin-center">
                        <v-checkbox
                          color="success"
                          class="my-0 mr-2 ml-0 view-checkbox"
                          :value="isAllChangeSelected"
                          @click="toggleAllChangePermmission"
                          hide-details
                        >
                        </v-checkbox>
                        <span class="text-capitalize pt-1 white--text">
                          change
                        </span>
                      </v-col>
                      <v-col class="d-flex algin-center">
                        <v-checkbox
                          color="success"
                          class="my-0 mr-2 ml-0 view-checkbox"
                          :value="isAllDeleteSelected"
                          @click="toggleAllDeletePermmission"
                          hide-details
                        >
                        </v-checkbox>
                        <span class="text-capitalize pt-1 white--text">
                          delete
                        </span>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col
                    class="px-10 py-3"
                    cols="12"
                    v-for="(permission, key) in userPermissions"
                    :key="key"
                  >
                    <v-row>
                      <v-col class="text-capitalize">
                        <span class="text-caption">
                          {{ key.replace(/_/g, " ") }}
                        </span>
                      </v-col>
                      <v-col>
                        <v-checkbox
                          color="success"
                          class="mt-1"
                          :name="`${key}-view`"
                          v-model="permission.view"
                          hide-details
                          @change="valueChanged(key, permission.view, 'view')"
                        >
                        </v-checkbox>
                      </v-col>
                      <v-col>
                        <v-checkbox
                          color="success"
                          class="mt-1"
                          :name="`${key}-add`"
                          v-model="permission.add"
                          hide-details
                          @change="valueChanged(key, permission.add, 'add')"
                        >
                        </v-checkbox>
                      </v-col>
                      <v-col>
                        <v-checkbox
                          color="success"
                          class="mt-1"
                          :name="`${key}-change`"
                          v-model="permission.change"
                          hide-details
                          @change="
                            valueChanged(key, permission.change, 'change')
                          "
                        >
                        </v-checkbox>
                      </v-col>
                      <v-col>
                        <v-checkbox
                          color="success"
                          class="mt-1"
                          :name="`${key}-delete`"
                          hide-details
                          v-model="permission.delete"
                          @change="
                            valueChanged(key, permission.delete, 'delete')
                          "
                        >
                        </v-checkbox>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-form>
        </v-card>
      </template>
      <template #actions>
        <SecondaryButton
          id="roleReset"
          @click="clear()"
          v-show="!editMode"
          btnClass="mr-2 text-uppercase rounded-lg"
          name="Reset"
        >
        </SecondaryButton>
        <PrimaryButton
          id="roleSubmit"
          btnClass="text-uppercase rounded-lg"
          :disabled="!isValid"
          @click.prevent="submitRoleForm()"
          name="Submit"
        >
        </PrimaryButton>
      </template>
    </BaseFormLayout>
  </div>
</template>

<script>
import { bus } from "@/main";
import BaseFormLayout from "@/components/LayoutComponents/BaseFormLayout.vue";
import { configurationModule } from "@/utils/moduleMapping";

export default {
  layout: "mainLayout",
  components: {
    BaseFormLayout,
  },
  props: {
    editMode: Boolean,
  },
  data() {
    return {
      configurationModule,
      isAllChecked: false,
      formErrors: {},
      selectedKey: {},
      nonFieldError: [],
      selectedPermission: [],
      isValid: true,

      roleDetails: {},
      userPermissions: {
        user: {
          delete: false,
          change: false,
          add: false,
          view: false,
        },
        trip_planning: {
          delete: false,
          change: false,
          add: false,
          view: false,
        },
        trip: {
          delete: false,
          change: false,
          add: false,
          view: false,
        },
        report: {
          delete: false,
          change: false,
          add: false,
          view: false,
        },
        order: {
          delete: false,
          change: false,
          add: false,
          view: false,
        },
        operation: {
          delete: false,
          change: false,
          add: false,
          view: false,
        },
        integration: {
          delete: false,
          change: false,
          add: false,
          view: false,
        },
        fleet: {
          delete: false,
          change: false,
          add: false,
          view: false,
        },
        customer: {
          delete: false,
          change: false,
          add: false,
          view: false,
        },
        configuration: {
          delete: false,
          change: false,
          add: false,
          view: false,
        },
      },
      backRoute: { path: "/admin/roles" },
    };
  },
  watch: {
    roleDetails: {
      handler() {
        this.formErrors = {};
      },
      deep: true,
    },
  },
  computed: {
    isAllViewSelected() {
      return Object.values(this.userPermissions).every((obje) => obje.view);
    },
    isAllAddSelected() {
      return Object.values(this.userPermissions).every((obje) => obje.add);
    },
    isAllChangeSelected() {
      return Object.values(this.userPermissions).every((obje) => obje.change);
    },
    isAllDeleteSelected() {
      return Object.values(this.userPermissions).every((obje) => obje.delete);
    },
    isAllSelected() {
      return (
        this.isAllAddSelected &&
        this.isAllChangeSelected &&
        this.isAllDeleteSelected &&
        this.isAllViewSelected
      );
    },
    anyPermissionSelected() {
      return Object.values(this.userPermissions).every((obje) => {
        return Object.values(obje).every((val) => val == false);
      });
    },
    userDetails() {
      let obj = this.$helper.getUserDetailsLocalStorage();
      if (obj) {
        return obj;
      }
    },
  },
  methods: {
    toggleAllViewPermission() {
      let obj = { ...this.userPermissions };
      if (this.isAllViewSelected) {
        Object.values(obj).map((module) => {
          module.view = false;
        });
      } else {
        Object.values(obj).map((module) => {
          module.view = true;
        });
      }
      this.userPermissions = obj;
    },
    toggleAllAddPermission() {
      let obj = { ...this.userPermissions };
      if (this.isAllAddSelected) {
        Object.values(obj).map((module) => {
          module.add = false;
        });
      } else {
        Object.values(obj).map((module) => {
          module.add = true;
          module.view = true;
        });
      }
      this.userPermissions = obj;
    },
    toggleAllChangePermmission() {
      let obj = { ...this.userPermissions };
      if (this.isAllChangeSelected) {
        Object.values(obj).map((module) => {
          module.change = false;
        });
      } else {
        Object.values(obj).map((module) => {
          module.change = true;
          module.view = true;
          module.add = true;
        });
      }
      this.userPermissions = obj;
    },
    toggleAllDeletePermmission() {
      let obj = { ...this.userPermissions };
      if (this.isAllDeleteSelected) {
        Object.values(obj).map((module) => {
          module.delete = false;
        });
      } else {
        Object.values(obj).map((module) => {
          module.delete = true;
          module.add = true;
          module.view = true;
          module.change = true;
        });
      }
      this.userPermissions = obj;
    },
    selectAllPermission() {
      let obj = { ...this.userPermissions };
      if (this.isAllSelected) {
        Object.values(obj).map((module) => {
          module.add = false;
          module.view = false;
          module.delete = false;
          module.change = false;
        });
      } else {
        Object.values(obj).map((module) => {
          module.add = true;
          module.view = true;
          module.delete = true;
          module.change = true;
        });
      }
      this.userPermissions = obj;
    },
    setRoleFormDetails(id) {
      this.$api.role
        .getRoleObject(id)
        .then((res) => {
          this.roleDetails = res.data;
          this.userPermissions = res.data.permissions;
        })
        .catch((err) => {
          this.$notifier.showMessage({
            content: "Couldn't fetch data",
            color: "error",
          });
        });
    },
    valueChanged(obj, input, type) {
      let moduleName = obj;
      let permission = input;
      let setAllTrue = {
        add: true,
        change: true,
        delete: true,
        view: true,
      };
      let setAllFalse = {
        add: false,
        change: false,
        delete: false,
        view: false,
      };
      if (permission && type == "delete") {
        this.userPermissions[moduleName] = setAllTrue;
      } else if (!permission && type == "view") {
        this.userPermissions[moduleName] = setAllFalse;
      } else if (permission && type == "change") {
        this.userPermissions[moduleName].add = true;
        this.userPermissions[moduleName].view = true;
        this.userPermissions[moduleName].change = true;
      } else if (!permission && type == !"view") {
        this.userPermissions[moduleName].type = false;
      }
      this.$forceUpdate();
    },
    submitRoleForm() {
      if (this.anyPermissionSelected) {
        bus.$emit("showToastMessage", {
          message: "Please select permission before submitting",
          color: "error",
        });
        return;
      }
      this.roleDetails.permissions = { ...this.userPermissions };
      let params = { ...this.roleDetails };
      bus.$emit("showLoader", true);
      if (!this.editMode) {
        this.$api.role
          .addRole(params)
          .then(() => {
            bus.$emit("showLoader", false);
            bus.$emit("showToastMessage", {
              message: "Added Role Successfully!",
              color: "success",
            });
            this.$router.push({ name: "role" });
          })
          .catch((err) => {
            console.error(err);
            bus.$emit("showLoader", false);
            this.formErrors = err.data;
          });
      } else {
        let postData = { ...this.roleDetails };
        // postData.userPermissions = this.permissions;
        const obj = {
          id: this.roleDetails.id,
          data: postData,
        };
        this.$api.role
          .updateRole(obj)
          .then((result) => {
            bus.$emit("showLoader", false);
            bus.$emit("showToastMessage", {
              message: "Updated Role Successfully!",
              color: "success",
            });
            this.$router.push({ name: "role" });
          })
          .catch((err) => {
            console.error(err);
            bus.$emit("showLoader", false);
            this.formErrors = err.data;
          });
      }
    },
    clear() {
      this.selectedPermission = [];
      this.roleDetails = {
        id: null,
        is_deletable: null,
      };
      this.$refs.roleForm.reset();
      this.isAllChecked = false;
    },
  },
  mounted() {
    if (this.userDetails.company_details.configuration.has_items) {
      this.userPermissions.item = {
        delete: false,
        change: false,
        add: false,
        view: false,
      };
    }
    if ("id" in this.$route.params) {
      this.setRoleFormDetails(this.$route.params.id);
    }
  },
};
</script>
<style lang="scss">
.view-checkbox .v-input--selection-controls__input .v-icon {
  background-color: white;
}
</style>
